<template>
  <div class="material">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem to="/host/index/home">首页</BreadcrumbItem>
          <BreadcrumbItem>设置</BreadcrumbItem>
          <BreadcrumbItem>项目管理</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">项目管理</div>
        <!-- <Input search placeholder="请输入关键字" v-model="search" @on-search="searchPro"
                    style="width:230px;margin-top:20px;" /> -->
      </div>
      <!-- <div class="header-tool-box">
                <div class="htb-item" @click="clickDetail">
                    <span>+新增</span>
                </div>
            </div> -->
    </div>
    <div class="layout-content" style="background: transparent">
      <div v-if="list.length">
        <el-table
          :header-cell-style="{
            background: '#f8f8f9',
            color: '#515a6e',
            fontSize: '12px',
          }"
          :row-style="{ height: '0' }"
          :cell-style="{ padding: '4px 0' }"
          border
          :data="list"
          style="width: 100%; font-size: 12px"
        >
          <el-table-column
            :show-overflow-tooltip="true"
            prop="name"
            label="中文名称"
            align="center"
          />
          <el-table-column
            :show-overflow-tooltip="true"
            prop="nameEn"
            label="英文名称"
            align="center"
          />
          <!-- <el-table-column prop="templateFileUrl" label="模板文件" align="center">
                        <template slot-scope="scope">
                            <span class="lookClass" @click="lookClickFile(scope.row.templateFileUrl)">点击查看</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="isUpload" label="需要上传回执" align="center">
                        <template slot-scope="scope">
                            <span v-if="scope.row.isUpload">是</span>
                            <span v-else>否</span>
                        </template>
                    </el-table-column> -->
          <!-- <el-table-column prop="displayOrder" label="显示顺序" align="center" /> -->
          <el-table-column prop="startTime" label="开始时间" align="center">
            <template slot-scope="scope">
              {{ scope.row.startTime | moment("YYYY/MM/DD") }}
            </template>
          </el-table-column>
          <el-table-column prop="endTime" label="结束时间" align="center">
            <template slot-scope="scope">
              {{ scope.row.endTime | moment("YYYY/MM/DD") }}
            </template>
          </el-table-column>
          <el-table-column prop="exHall" label="举办地" align="center" />
          <el-table-column prop="isOpen" label="展会设置">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.isOpen"
                class="switchStyle"
                active-color="#1890FF"
                inactive-color="#CCCCCC"
                active-text="正常"
                inactive-text="禁用"
                @change="SwitchChange(scope.row)"
              />
            </template>
          </el-table-column>

          <el-table-column
            :show-overflow-tooltip="true"
            prop="displayOrder"
            label="报名地址"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ getUrl(scope.row.id) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            width="200px"
            align="center"
          >
            <template slot-scope="scope">
              <span
                class="lookClass tag-read"
                :data-clipboard-text="getUrl(scope.row.id)"
                @click="copy(scope.row)"
                >复制链接</span
              >
              <span
                class="lookClass tag-read"
                @click="showId(scope.row)"
                style="margin-left: 10px"
                >编辑</span
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="u-empty" v-else>暂无数据</div>
    </div>
    <projectAdd
      :show="show"
      :currentId="currentId"
      @finish="init()"
      @close="show = false"
    />
  </div>
</template>
  
<script>
import { mapGetters, mapActions } from "vuex";
import Clipboard from "clipboard";
import projectAdd from "./components/project-add";
export default {
  name: "host-ex-list",
  data() {
    return {
      resetShow: false,
      resetInfo: {},
      editBrand: false,
      editBrandnfo: null,
      editPrize: false,
      editPrizeInfo: null,
      editTopic: false,
      editTopicnfo: null,
      editToTop: false,
      editToTopInfo: null,
      search: "",
      editInfo: null,
      list: [],
      show: false,
      selection: [], // 选中项目
      currentId: "",
    };
  },
  components: {
    projectAdd,
  },
  computed: {
    ...mapGetters({
      hostExhibitionId: "hostSetModule/getHostExhibitionId",
    }),
  },
  created() {
    this.init();
    console.log();
  },
  methods: {
    ...mapActions({
      receiptGet: "hostSetModule/receiptGet",
      receiptDelete: "hostSetModule/receiptDelete",
      appExhibition: "hostSetModule/appExhibition", //获取所有展会
      exhibitionIdCurrent: "hostSetModule/exhibitionIdCurrent",
      setManageSettingQ: "hostSetModule/setManageSettingQ", //获取
      setManageUpdate: "hostSetModule/setManageUpdate", //设置
    }),
    async showId(res) {
      console.log(res);
      this.currentId = "";
      this.show = true;
      this.currentId = res.id;
      // let data = await this.exhibitionIdCurrent({ id: res.id });
      // console.log(data, 11111);
    },
    clickDetail() {
      this.$router.push(`/host/index/setting/list2Detail?opt=null`);
    },
    editMember(row) {},
    getUrl(id) {
      return location.origin + "/ex-register/register?exhibitionId=" + id;
    },
    async SwitchChange(e) {
      console.log(e);

      let opt = {
        providerName: "Global",
        providerKey: "",
        values: [{ name: "CurrentExhibitionId", value: e.isOpen ? e.id : "" }],
      };
      let res = await this.setManageUpdate(opt);
      if (res) {
        this.$message.success("操作成功");
        this.init();
      } else {
        this.$message.success("操作失败");
      }
    },
    async init() {
      let opt = {
        providerName: "Global",
        names: ["CurrentExhibitionId"],
      };

      let res = await this.setManageSettingQ(opt);
      let proData = await this.appExhibition();
      if (proData && proData.length > 0) {
        if (res && res.length > 0) {
          proData.forEach((item) => {
            if (item.id == res[0].value) {
              item.isOpen = true;
            } else {
              item.isOpen = false;
            }
          });
        }

        this.list = proData;
        this.list.forEach((item) => {
          if (item.id != this.currentId) {
            this.currentId = item.id;
          }
        });
      }

      console.log(res, 123123123234);
    },

    lookClickFile(e) {
      window.open(e, "_blank");
    },
    async deleteMember(scope) {
      scope._self.$refs[`popover-${scope.$index}`].doClose();
      let proData = await this.receiptDelete(scope.row.id);
      if (proData) {
        this.$message.success("删除成功");
        this.init();
      }
    },
    copy() {
      var clipboard = new Clipboard(".tag-read");
      clipboard.on("success", (e) => {
        console.log("复制成功");
        this.$message.success("复制成功");
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        console.log("该浏览器不支持自动复制");
        // 释放内存
        clipboard.destroy();
      });
    },
  },
};
</script>
  
<style scoped lang="scss">
.header-tool-utils {
  margin-top: 20px;

  button {
    margin-right: 20px;
  }
}

.logo {
  width: 60px;
  height: 60px;
  display: inline-block;
}

/deep/ .resetModal {
  display: flex;
  align-items: center;
  justify-content: center;

  .ivu-modal {
    top: 0;
  }

  .ivu-modal-body {
    padding: 24px 0 0 16px;
  }
}
</style>

<style lang="scss">
.switchStyle .el-switch__label {
  position: absolute;
  display: none;
  color: #fff;
}

.switchStyle .el-switch__label--left {
  z-index: 9;
  left: 20px;
}

.switchStyle .el-switch__label--right {
  z-index: 9;
  left: -2px;
}

.switchStyle .el-switch__label.is-active {
  display: block;
}

.switchStyle.el-switch .el-switch__core,
.el-switch .el-switch__label {
  width: 60px !important;
}
</style>
  
  